import type { GQL_ID } from '@@partner:types:graphql'
import type { AssemblingOrderInfo } from '@@partner:types:app'

import { gql, useQuery, useLazyQuery } from '@apollo/client'

import {
  ORDER_FIELDS,
  ORDER_SHOP_FIELDS,
  ORDER_TOTALS_FIELDS
} from '@@partner:graphql/shortcuts'

export interface OrderQueryVariables {
  order_id: GQL_ID
}
export interface OrderQuery {
  order: AssemblingOrderInfo
}

const GQL_QUERY_ASSEMBLING_ORDER_DETAILS = gql`
  query ($order_id: ID!) {
    order: assemblingOrderDetails(order_id: $order_id) {
      id
      assembledOrderTotal
      diffTotals
      orderTotal
      saledCost
      deliveryCost
      shop_id
      status
      isPrepayable
      isPaid
      isWaitingPayment

      orderBoxComment
      orderBoxes {
        id
        shop_id
        name
        number
        sort_order
      }

      customerProducts {
        id
        order_id
        amount: count
        status
        weight
        price
        total
        total_weight
        canSetAssembled
        name
        assemblingInfo {
          count
          weight
          total
        }
        product {
          id
          name
          preview {
            url
          }
          price_type
          count_multiplier
          min_count
        }
      }
    }
  }
`

export const useFetchAssemblerOrder = (order_id?: GQL_ID) => {
  return useQuery<OrderQuery, OrderQueryVariables>(
    GQL_QUERY_ASSEMBLING_ORDER_DETAILS,
    {
      variables: {
        order_id: order_id!
      },
      skip: !order_id,
      fetchPolicy: 'cache-first'
      // fetchPolicy: 'cache-and-network'
    }
  )
}

export const useLazyFetchAssembleOrder = (order_id?: GQL_ID) => {
  return useLazyQuery<OrderQuery, OrderQueryVariables>(
    GQL_QUERY_ASSEMBLING_ORDER_DETAILS,
    {
      variables: {
        order_id: order_id!
      }
    }
  )
}
